import React, { useState } from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CreateFolderOrFileModal from './modal/CreateFolderOrFileModal';
import { AddButton } from '../util/buttons';
import FolderFileDragContainer from './FolderFileDragContainer';
import FolderPathContainer from './FolderPathContainer';
import MoveModal from './modal/MoveModal';
import { stopEvent } from '../util/domUtils';
import { useGetFoldersAndFiles } from '../services/folders_and_files.service';

/**
 * @param modelName string to show ex. claim_project_report.project_name
 * @param targetModelId pass the model id, must come from useParams or will have strange behaviour
 * @param type can be: ClaimProjectReport
 * @param goToFolder goes to a url with passed folder id
 *
 * This will render folders and files of a model such as ClaimProjectReport.
 * It can be used for ClaimGroup and Company when they are added in the backend
 * by just simply passing ClaimGroup or Company as type. This name corresponds to
 * model name in backend
 *
 */

const FoldersAndFiles = _ref => {
  let {
    modelName,
    targetModelId,
    type,
    goToFolderQuery,
    getFileUploadersAndVirtualFolderPath,
    canEditExistingDocumentsOrFolders = true,
    rootFolderId = null,
    userClaimGroupAbilities
  } = _ref;
  const [setFolders, setFiles, setCurrentFolderId, currentFolderId, folders, files, currentPath] = useGetFoldersAndFiles(targetModelId, type, rootFolderId);
  const [createModalShow, setCreateModalShow] = useState(false);
  const [moveModalShow, setMoveModalShow] = useState(false);
  const [modalRoute, setModalRoute] = useState('');
  const [draggedElement, setDraggedElement] = useState({});
  const [currentAction, setCurrentAction] = useState(null);
  const [droppedElement, setDroppedElement] = useState({});
  const handleDragEnter = e => {
    stopEvent(e, false);
    if (e.dataTransfer.types.includes('Files')) {
      showCreateModal('folder_files');
    }
  };
  const {
    t
  } = useTranslation();
  const showCreateModal = route => {
    setCreateModalShow(true);
    setModalRoute(route);
  };
  const hideAndEmptyElements = () => {
    setMoveModalShow(false);
    setDraggedElement({});
    setDroppedElement({});
  };
  const isFile = el => el.hasOwnProperty('download_link');
  const showFolderOrFileDropModal = (draggedElement, droppedElement) => {
    setDroppedElement({
      ...droppedElement
    });
    const isDraggedElementFile = isFile(draggedElement);
    const isDroppedElementFile = isFile(droppedElement);
    const draggedFileIsOverItsOwnFolder = isDraggedElementFile && draggedElement.folder_id === droppedElement.id;
    if (!draggedElement.name || !droppedElement.name || isDroppedElementFile || draggedElement.id === droppedElement.id || draggedFileIsOverItsOwnFolder || !isDraggedElementFile && draggedElement.parent_folder_id === droppedElement.id || draggedElement.virtual_folder) {
      return;
    }

    // Action after check:

    //`Dropped ${draggedElement.name} into ${droppedElement.name}`
    setMoveModalShow(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    onDragEnter: handleDragEnter,
    onDragOver: e => stopEvent(e, false),
    onDragLeave: e => stopEvent(e, false),
    onDrop: e => stopEvent(e, false),
    "data-testid": "dropZone"
  }, /*#__PURE__*/React.createElement(FolderPathContainer, {
    goToFolderQuery: goToFolderQuery,
    path: currentPath,
    setCurrentFolderId: setCurrentFolderId,
    modelName: modelName,
    showFolderOrFileDropModal: showFolderOrFileDropModal,
    draggedElement: draggedElement,
    setDraggedElement: setDraggedElement,
    setCurrentAction: setCurrentAction,
    getFileUploadersAndVirtualFolderPath: getFileUploadersAndVirtualFolderPath,
    userCanDrag: canEditExistingDocumentsOrFolders,
    showPath: true
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(CreateFolderOrFileModal, {
    route: modalRoute,
    show: createModalShow,
    onHide: () => setCreateModalShow(false),
    currentFolderId: currentFolderId,
    allData: modalRoute === 'folders' ? folders : files,
    setAllData: modalRoute === 'folders' ? setFolders : setFiles,
    targetModelId: targetModelId,
    type: type,
    userClaimGroupAbilities: userClaimGroupAbilities
  }), /*#__PURE__*/React.createElement(MoveModal, {
    show: moveModalShow,
    hideAndEmptyElements: () => hideAndEmptyElements(),
    draggedElement: draggedElement,
    droppedElement: droppedElement,
    route: isFile(draggedElement) ? 'folder_files' : 'folders',
    allData: isFile(draggedElement) ? files : folders,
    setAllData: isFile(draggedElement) ? setFiles : setFolders,
    isFile: isFile
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(AddButton, {
    variant: "primary",
    onClick: () => showCreateModal('folders'),
    disabled: false,
    className: 'ms-auto me-3',
    text: t('folder')
  }), /*#__PURE__*/React.createElement(AddButton, {
    variant: "primary",
    onClick: () => showCreateModal('folder_files'),
    disabled: false,
    className: 'me-3',
    text: t('file')
  })), /*#__PURE__*/React.createElement(FolderFileDragContainer, {
    goToFolderQuery: goToFolderQuery,
    folders: folders,
    files: files,
    setFiles: setFiles,
    setFolders: setFolders,
    setCurrentFolderId: setCurrentFolderId,
    showFolderOrFileDropModal: showFolderOrFileDropModal,
    draggedElement: draggedElement,
    setDraggedElement: setDraggedElement,
    currentAction: currentAction,
    setCurrentAction: setCurrentAction,
    canEditExistingDocumentsOrFolders: canEditExistingDocumentsOrFolders
  }), /*#__PURE__*/React.createElement("p", null, currentAction));
};
export default FoldersAndFiles;